import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import './Logo.scss';

interface LogoProps {
    className?: string
}

export const Logo: FC<LogoProps> = ({className}) => {
    const { i18n } = useTranslation();
    const imageLang = i18n.language.toLowerCase().startsWith('fr') ? "Sante_FR" : "Health_EN";
    const altText = i18n.language.toLowerCase().startsWith('fr') ? "Logo Telus Santé" : "Telus Health Logo";

    return (
        <div className={clsx('logos_wrapper', className)}>
            <picture>
                <source srcSet={`/images/TELUS_${imageLang}_logo_white.svg`} media="(prefers-color-scheme: dark)" />
                <source srcSet={`/images/TELUS_${imageLang}_Hor_2021_Digital_RGB.png`} media="(prefers-color-scheme: light)" />
                <img height={48} src={`/images/TELUS_${imageLang}_Hor_2021_Digital_RGB.png`} alt={altText} />
            </picture>
        </div>
    );
}